import PageLayout from "@/screens/Layout/PageLayout";
import useIsMobile from "@/hooks/useIsMobile";
import LiveTVPage from "@/screens/LiveTVPage";

export default function Category({
  latestStoryData = null,
  latestVideoData = null,
  faqData=null,
  storyPageData = null,
}) {
  const isMobileDevice = useIsMobile();

  const metaDesc = {
    title: "India Today Live TV: Watch India Today Live TV in English - NewsTak",
    description: "Watch India Today Live TV for free on Newstak. Watch the latest headlines, breaking news and stream live tv anytime, anywhere with seamless online access.",
    keywords:  ` India Today live TV, live TV India Today, online India Today stream, India Today news live, free live TV India Today, latest India Today updates, live news streaming, India Today breaking news, India Today current affairs, live tv news channel​, live tv news channel​ free, live tv free, live tv channel`,
  };
  const liveTV_id = "livetv-it";
  const title='India Today Live TV'
  const description = `
  <div class=" mt-3 justify-center  ">
    <h2 class="text-xl font-bold text-gray-800 ">India Today Live TV :</h2>
    <p class="text-gray-700 ">
      <span class="font-bold">इंडिया टुडे</span> (India Today) Channel भारत के प्रमुख और लोकप्रिय <span class="font-medium">News Channels</span> में से एक है. 
      Channel की शुरुआत 2003 में की गई थी. इसमें News <span class="italic">English</span> भाषा में दिखाई जाती है. 
      India Today Channel पर आप <span class="font-medium">24*7 भरोसेमंद News</span> देख सकते हैं. India Today Channel को 
      <span class="font-medium">Aajtak Hindi Channel</span> के बाद English भाषा में भी पत्रकारिता के ऊंचे मापदंड स्थापित करने के लिए लॉन्च किया गया था. 
      इंडिया टुडे न्यूज Channel का <span class="font-medium">Owner India Today Group</span> है.
    </p>
  
    <h2 class="text-xl font-semibold text-gray-800 ">India Today Channel Feature :</h2>
    <p class="text-gray-700 ">
      India Today Channel का मेन फोकस <span class="font-medium">Live Coverage</span> और <span class="font-medium">Trending News</span> पर होता है. 
      India Today Channel पर आपको सभी तरीके की News दिखाई जाती हैं, जैसे <span class="font-medium">Crime News, Sports News, Business News</span> और 
      <span class="font-medium">Political News</span>. India Today खास कर अपने News की <span class="font-medium">विश्वसनीयता</span> के लिए जाना जाता है.
    </p>
  
    <h2 class="text-xl font-semibold text-gray-800 ">Main Program :</h2>
    <ul class="list-decimal list-inside  text-gray-700 space-y-1">
      <li>News Today</li>
      <li>Newstrack With Rahul Kanwal</li>
      <li>To The Point</li>
      <li>India First</li>
      <li>5ive Live</li>
      <li>First Up</li>
      <li>In Da Club</li>
      <li>Battle Cry</li>
      <li>World Today</li>
      <li>Jab We Met</li>
      <li>Election</li>
      <li>Business Today</li>
    </ul>
  
    <h2 class="text-xl font-semibold text-gray-800 ">Digital and Social Media Presence :</h2>
    <p class="text-gray-700 ">
      India Today न्यूज चैलन तमाम <span class="font-medium">Social Media Platforms</span> पर भी उपलब्ध है. Channel की अपनी 
      <span class="font-medium">Website</span> भी है. यहां भी आप <span class="font-medium">24*7 न्यूज</span> देख सकते हैं, पढ़ सकते हैं. 
      India Today न्यूज चैनल से जुड़े Social Media प्लेटफॉर्म्स और Website पर आसान भाषा का इस्तेमाल किया जाता है ताकि लोग उसे 
      आसानी से पढ़कर समझ सकें.
    </p>
  
    <p class="text-gray-700">
      <span class="font-bold">India Today Contact No.:</span> 911204807100
    </p>
  </div>
  `;
  
  
  
  return (
    <>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <LiveTVPage
          isMobileDevice={isMobileDevice}
          metaDescription={metaDesc}
          liveTV_id={liveTV_id}
          title={title}
          description={description}
          faqData={faqData}
          storyPageData={storyPageData}
        />
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");

  try {
    let url = ctx?.resolvedUrl;
    //* remove query param from url
    url = url.split("?")[0];
    const { getFaqBySlug } = await import("@/handlers/faq");
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed, getContentByType } = await import(
      "@/handlers/content"
    );
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    const faqRedisKey = getRedisApiKey({
        redisPrefix: "PREFIX_REDIS_ROS",
        params: { api: "staticpages", url: "indiatoday-livetv" },
      });
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });
    const videosRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "newslist",
        page: page,
        display: 12,
        type: "video",
      },
    });

    const storiesRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "newslist",
        page: page,
        display: 12,
        type: "story",
      },
    });

    let [faqData,{ latestStoryData, latestVideoData }, storyPageData] = await Promise.all([
        fetchRedisWrapper(faqRedisKey, () =>
            getFaqBySlug({
              url: url// 'aajtak-livetv', //"kumbha-faq",
            })
          ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      fetchRedisWrapper(videosRedisKey, () =>
        getContentByType({
          type: "video",
          page: page,
          display: 12,
        })
      ),
      fetchRedisWrapper(storiesRedisKey, () =>
        getContentByType({
          type: "story",
          page: page,
          display: 12,
        })
      ),
    ]);

    let headerCache = storyPageData?.cache;
    setPageTTL(ctx, headerCache?.akamai_ttl);

    return {
      props: {
        latestStoryData,
        latestVideoData,
        faqData,
        storyPageData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
